/** Like Object.defineProperty() but with type inference */
export function objectDefineProperty(obj, prop, { get, ...args }) {
    Object.defineProperty(obj, prop, { ...args, get });
}
